import { Grid } from '@mantine/core';
import styles from 'src/financial/financial-data/financial-item/forms/common/FormLayout.module.css';
import React from 'react';

type GridPairProps = {
  first: React.ReactNode;
  second?: React.ReactNode;
  isHighlighted?: boolean;
  hide?: boolean;
  fullWidth?: boolean;
};

export const GridPair = ({
  first,
  second,
  isHighlighted = false,
  hide = false,
  fullWidth = false,
}: GridPairProps) =>
  !hide && (
    <Grid.Col span={fullWidth ? 12 : 6}>
      <Grid className={isHighlighted ? styles.highlightedGrid : undefined} py={'xs'} px={'sm'}>
        <Grid.Col span={second ? 6 : 12}>{first}</Grid.Col>
        {second && <Grid.Col span={6}>{second}</Grid.Col>}
      </Grid>
    </Grid.Col>
  );
